import api from 'services/api';
import {
  DEFAULT_RESPONSE_MODAL_NURSERY_DASHBOARD,
  DEFAULT_RESPONSE_NURSERY,
} from './types';
import { HttpCodes } from 'v2/resources/types/httpCode';
import {
  INursery,
  IQueryModalNurseryDashboard,
  IQueryParamsNursery,
  IResponseModalNurseryDashboard,
} from 'v2/resources/types/nurseries';

export const NurseriesServices = {
  getNurseries: async (
    queryParams: IQueryParamsNursery
  ): Promise<INursery[]> => {
    const response = await api.get('/dashboard/podsView', {
      params: queryParams,
    });

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_NURSERY;
  },

  getDataNuerseryModal: async (
    params: IQueryModalNurseryDashboard
  ): Promise<IResponseModalNurseryDashboard> => {
    const { cycleId, pondId } = params;
    const response = await api.get(
      `/dashboard/getPondByCycleAndPondId/${cycleId}/${pondId}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }

    return DEFAULT_RESPONSE_MODAL_NURSERY_DASHBOARD;
  },
};
